/* GROUPS */
export const GET_POSITIONS = "GET_POSITIONS"
export const GET_POSITIONS_ALL = "GET_POSITIONS_ALL"
export const GET_POSITIONS_SUCCESS = "GET_POSITIONS_SUCCESS"
export const GET_POSITIONS_ERROR = "GET_POSITIONS_ERROR"
